export default {
    exportName: 'AdminConsoleInfo',
    content: () => import('@/Fwamework/Core/Components/RestartWebAppAdminConsole.vue'),
    contentData: {
        key: 'RestartWebAppAdminConsole',
        visible: true
    }
};